// extracted by mini-css-extract-plugin
export default {"tableHeading":"TableHeader_tableHeading__eGJQY","tableHeading-white":"TableHeader_tableHeading-white__Ww8Yf"};